import {
    bgCircles,
    mobileBgCircles,
} from '@components/Products/FixedDeposits/utils/helper';
import useWindowDimensions from '@hooks/useWindowDimensions';

const BackgroundCircles = () => {
    const { width } = useWindowDimensions();
    const bgElements = width < 768 ? mobileBgCircles : bgCircles;
    return (
        <div className="absolute inset-0 top-[-170%] md:top-0 flex items-center justify-center">
            {bgElements.map((circle, index) => (
                <div
                    key={index}
                    className="absolute border-2 rounded-full border-basicWhite opacity-[5%]"
                    style={{
                        width: `${circle}px`,
                        height: `${circle}px`,
                    }}
                />
            ))}
        </div>
    );
};

export default BackgroundCircles;
